import React from 'react';
// import InputWithLabel from '../components/InputWithLabel';
import List from '../components/List';
import { useSemiPersistentState, storiesReducer, getAsyncStories } from '../hooks/hooks';
import StoryContext from '../contexts/StoryContext';
import TextFX from 'txt-fx';

const Home = () => {
  document.body.style.backgroundColor = 'white';
  const [searchTerm] = useSemiPersistentState(
    'search',
    ''
  );
  const [stories, dispatchStories] = React.useReducer(
    storiesReducer,
    []
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [title] = React.useState(() => {
    const titles = ['Ripped apart', 'Like rubber', 'Rest away', 'Dinner time', 'On the moon', 'When you are with me'];
    return titles[Math.floor(Math.random() * titles.length)];
  });

  React.useEffect(() => {
    document.body.style.backgroundColor = 'white';

    const fx = new TextFX.Shuffler();
    const element = document.querySelector('#headline');
    fx.shuffle(element, 100, 1, true);
    
    const fetchData = async () => {
      setIsLoading(true);
  
      try {
        const result = await getAsyncStories();
        dispatchStories({
          type: 'SET_STORIES',
          payload: result.data.stories,
        });
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
      }
    };
  
    fetchData();
  }, []);

  const handleRemoveStory = item => {
    dispatchStories({
      type: 'REMOVE_STORY',
      payload: item,
    });
  };

  const searchedStories = stories.filter(story => (
    story.tags.includes(searchTerm.toLowerCase()) ||
    story.title.toLowerCase().includes(searchTerm.toLowerCase())
  )
  );

  const data = {
    searchTerm,
    stories,
    searchedStories,
    onRemoveStory: handleRemoveStory,
  }


  return (
    <StoryContext.Provider value={data}>
      <div style={{
      }}>
        <section>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                flexWrap: 'wrap',
              }}>
                <h1 id="headline">{title}</h1>
              </div>
              {isError && <p>Something went wrong ...</p>}

              {isLoading ? (
                <p style={{
                  fontStyle: 'italic',
                }}>Loading ...</p>
              ) : (
                <>
                  <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                  }}>
                      <List onRemoveItem={handleRemoveStory}/>
                  </div>
                </>
              )}
        </section>
      </div>
    </StoryContext.Provider>
  );
};


export default Home;
